import { useState, useEffect, useContext, createContext } from "react";
import MGAShellLayout from "./components/shellLayout";
import mgaConstants from "./constants/index";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import AuthCallback from "./components/auth/authCallback";
import AppRoute from "./routes/AppRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MGAAssesment from "./pages/assessment";
import Tariff from "./Tarrif/Tariff";
import "./styles.scss";
import LibraryManagementHook from "./components/Library";
import { ColorSchemeProvider, MantineProvider } from "@mantine/core";
import { SeApp } from "@se/web-ui-react";
import { UserRegistration } from "./components/UserManagement";
import RegistrationLayout from "./components/UserManagement/RegistrationLayout";
import UserTable from "./components/UserManagement/userTable";
import DemandCharge from "./DemandCharge";
import PaginateSelectDemo from "./components/PaginateSelect/Demo";
import TermsAndConditions from "./pages/TaC/TermsAndConditions";
import { ValidateAssessmentTab } from "./routes/RouteHelpers";
import TicketManagement from "./components/Ticket/ticketTable";
import TicketDetails from "./components/Ticket/TicketDetails";
import CheckApiHealth from "./utils/checkApiHealth";
const ColorSchemeContext = createContext();

export const useColorScheme = () => useContext(ColorSchemeContext);
export const ColorSchemeContextProvider = ColorSchemeContext.Provider;

const App = () => {
  const [colorScheme, setColorScheme] = useState();

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    if (localStorage.getItem("mantine-color-scheme")) {
      setColorScheme(localStorage.getItem("mantine-color-scheme"));
    } else {
      setColorScheme("light");
    }
    // Listener for changes in system color scheme
    const handleChange = (event) => {
      const newColorScheme = event.matches ? "dark" : "light";
      // Set initial color scheme based on system preference
      const initialColorScheme = mediaQuery.matches ? "dark" : "light";
      localStorage.setItem("mantine-color-scheme", initialColorScheme);
      setColorScheme(initialColorScheme);
      initialColorScheme === "dark"
        ? document
            .getElementsByTagName("se-app")?.[0]
            ?.classList.add("se-theme-dark")
        : document
            .getElementsByTagName("se-app")?.[0]
            ?.classList.remove("se-theme-dark");
      setColorScheme(newColorScheme);
    };

    mediaQuery.addEventListener("change", handleChange);

    // Cleanup listener on component unmount
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const toggleColorScheme = (value) => {
    localStorage.setItem(
      "mantine-color-scheme",
      colorScheme === "dark" ? "light" : "dark"
    );
    setColorScheme(value || (colorScheme === "dark" ? "light" : "dark"));
  };

  useEffect(() => {
    colorScheme === "dark"
      ? document
          .getElementsByTagName("se-app")?.[0]
          ?.classList.add("se-theme-dark")
      : document
          .getElementsByTagName("se-app")?.[0]
          ?.classList.remove("se-theme-dark");
  }, [colorScheme]);

  return (
    <ColorSchemeProvider
      colorScheme={colorScheme || localStorage.getItem("mantine-color-scheme")}
      toggleColorScheme={toggleColorScheme}
    >
      <MantineProvider
        withGlobalStyles
        withNormalizeCSS
        theme={{
          colorScheme: colorScheme,
          fontFamily: "Nunito",
          colors: {
            dark: [
              "#d5d7e0",
              "#a0a3b1",
              "#6c6f7e",
              "#505559",
              "#434B4D",
              "#3a3c3e",
              // "#2e3032",
              "#1f2729",
              "#232526",
              "#1c1e20",
              "#141516",
            ],
            seGreen: ["#3dcd58"],
            seOrange: ["#e47f00"],
          },
          components: {
            Input: {
              styles: () => ({
                input: {
                  borderRadius: "0px",
                  "&::placeholder": {
                    color: "transparent",
                    opacity: 0,
                  },
                },
              }),
            },
            InputWrapper: {
              styles: () => ({
                input: {
                  width: "90%",
                  "&::placeholder": {
                    color: "transparent",
                    opacity: 0,
                  },
                },
              }),
            },
            TextInput: {
              styles: () => ({
                input: {
                  borderRadius: "0px",
                  "&::placeholder": {
                    color: "transparent",
                    opacity: 0,
                  },
                },
              }),
            },
            NumberInput: {
              styles: () => ({
                input: {
                  borderRadius: "0px",
                  "&::placeholder": {
                    color: "transparent",
                    opacity: 0,
                  },
                },
              }),
            },
            Textarea: {
              styles: () => ({
                input: {
                  borderRadius: "0px",
                  "&::placeholder": {
                    color: "transparent",
                    opacity: 0,
                  },
                },
              }),
            },
            Select: {
              styles: () => ({
                rightSection: {
                  pointerEvents: "none",
                },
              }),
            },
          },
        }}
      >
        <SeApp
          className={colorScheme === "dark" ? "se-theme-dark" : "isLight"}
          security=""
          style={{ zoom: "85%", position: "fixed" }}
        >
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <AppRoute
                    layout={MGAShellLayout}
                    component={Dashboard}
                    auth="yes"
                  />
                }
              />
              <Route
                path="/library"
                element={
                  <AppRoute
                    layout={MGAShellLayout}
                    component={LibraryManagementHook}
                    auth="yes"
                  />
                }
              />
              <Route
                path="/tickets"
                element={
                  <AppRoute
                    layout={MGAShellLayout}
                    component={TicketManagement}
                    auth="yes"
                  />
                }
              />
              <Route
                path="/tickets/:ticketId"
                element={
                  <AppRoute
                    layout={MGAShellLayout}
                    component={TicketDetails}
                    auth="yes"
                  />
                }
              />
              <Route
                path={mgaConstants.routes.mgaAssessment}
                element={
                  // <ValidateAssessmentTab>
                    <AppRoute
                      layout={MGAShellLayout}
                      component={MGAAssesment}
                      auth="yes"
                    />
                  // </ValidateAssessmentTab>
                }
              />
              <Route
                path={mgaConstants.routes.callback}
                layout={MGAShellLayout}
                element={<AuthCallback />}
              />
              <Route
                path={"/users"}
                element={
                  <AppRoute
                    layout={MGAShellLayout}
                    component={UserTable}
                    auth="yes"
                  />
                }
              />
                
              {/* <Route path="/tariff" element={<DemandCharge />} />
              <Route path="/selection" element={<PaginateSelectDemo />} /> */}

              <Route
                path="/registration"
                element={
                  <AppRoute
                    layout={RegistrationLayout}
                    component={UserRegistration}
                    auth="yes"
                  />
                }
              />
              <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
              <Route path="/healthcheck" element={<CheckApiHealth />} />
            </Routes>
          </BrowserRouter>
        </SeApp>
      </MantineProvider>
    </ColorSchemeProvider>
  );
};

export default App;
